import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { SuspenseLoader } from 'components';

const ArticleList = React.lazy(() => import('./article-list'));
const ArticleCreate = React.lazy(() => import('./article-create'));
const ArticlePreview = React.lazy(() => import('./article-preview'));

const ArticlesBase = () => (
  <React.Suspense fallback={<SuspenseLoader />}>
    <Routes>
      <Route path="/" element={<ArticleList />} />
      <Route path="/create" element={<ArticleCreate />} />
      <Route path="/edit/:id" element={<ArticleCreate />} />
      <Route path="/preview/:id" element={<ArticlePreview />} />
    </Routes>
  </React.Suspense>
);

export default ArticlesBase;
